import React from 'react';
import './style.scss';

const AchRemind: React.FC = () => {
    return (
        <ul className="ach-remind-root">
            <li>{__('Before you continue:')}</li>
            <li>
                1. {__('Please check that your bank account supports ACH transactions; some savings accounts may not.')}
            </li>
            <li>2. {__("You will not be able to cancel the deposit request once it's submitted.")}</li>
        </ul>
    );
};

export default AchRemind;
